export default __webpack_public_path__ + "static/media/sybil-logo.2d50e16f.svg";